// extracted by mini-css-extract-plugin
export default {"Contact_Top":"Contact_Contact_Top__gwUr1","texts":"Contact_texts__gLsux"};